import { jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { getPairwiseOverviewLinearViewOptions } from "./getPairwiseOverviewLinearViewOptions";
import { AlignmentView } from "./index";
export function PairwiseAlignmentView(props) {
  const [currentPairwiseAlignmentIndex, setCurrentPairwiseAlignmentIndex] = useState(void 0);
  const { pairwiseAlignments, pairwiseOverviewAlignmentTracks } = props;
  if (currentPairwiseAlignmentIndex > -1) {
    const alignmentTracks = pairwiseAlignments[currentPairwiseAlignmentIndex];
    const templateLength = alignmentTracks[0].alignmentData.sequence.length;
    const firstBaseIndex = alignmentTracks[1].alignmentData.sequence.search(/[^-]/);
    const scrollPercentageToJumpTo = firstBaseIndex > -1 ? firstBaseIndex / templateLength : 0;
    return /* @__PURE__ */ jsx(
      AlignmentView,
      {
        ...{
          ...props,
          sequenceData: {
            //pass fake seq data in so editor interactions work
            sequence: Array.from(templateLength).map(() => "a").join("")
          },
          allowTrackRearrange: false,
          alignmentTracks,
          hasTemplate: true,
          isPairwise: true,
          scrollPercentageToJumpTo,
          currentPairwiseAlignmentIndex,
          handleBackButtonClicked: () => {
            setCurrentPairwiseAlignmentIndex(void 0);
          }
        }
      }
    );
  } else {
    return /* @__PURE__ */ jsx(
      AlignmentView,
      {
        ...{
          ...props,
          alignmentTracks: pairwiseOverviewAlignmentTracks,
          allowTrackRearrange: false,
          allowTrimming: false,
          hasTemplate: true,
          isPairwise: true,
          isInPairwiseOverviewView: true,
          isFullyZoomedOut: true,
          noClickDragHandlers: true,
          linearViewOptions: getPairwiseOverviewLinearViewOptions,
          handleSelectTrack: (trackIndex) => {
            setCurrentPairwiseAlignmentIndex(trackIndex - 1);
          }
        }
      }
    );
  }
}
